import restoreSpacesInText from "restoreSpacesInText";

function getDisplayValue(searchParams) {
  if (!searchParams.city && !searchParams.region && !searchParams.postcode && !searchParams.location) {
    return "";
  }

  function displayCityAndRegion(city = "", region = "") {
    const delimiter = city && region ? ", " : "";
    if (region && !city) {
      // Remove commas when displaying regions only, so that cases such as
      // "Washington, D.C." are not counted as a city="Washington" and
      // region="D.C.".
      region = region.replace(/,/g, "");
    }
    return `${city || ""}${delimiter}${region || ""}`;
  }

  let city = searchParams.locationValue && searchParams.locationValue.city || "";
  let region = searchParams.locationValue && searchParams.locationValue.region || "";
  if (city || region) {
    return displayCityAndRegion(city, region);
  }
  if (searchParams.postcode) {
    return searchParams.locationValue ? searchParams.locationValue.postcode : searchParams.postcode;
  }
  if (searchParams.location) {
    return searchParams.location;
  }

  if (searchParams.city) {
    city = restoreSpacesInText(searchParams.city);
  }
  if (searchParams.region) {
    region = restoreSpacesInText(searchParams.region);
  }

  return displayCityAndRegion(city, region);
}

export default getDisplayValue;
